// src/components/shared/FilterBar.jsx
import React from 'react';
import PropTypes from 'prop-types';
import {
  Paper,
  Grid,
  Box,
  Button
} from '@mui/material';
import { 
  SearchOutlined,
  RestartAltOutlined
} from '@mui/icons-material';

/**
 * Componente para barras de filtro consistentes
 * 
 * @param {Object} props - Propiedades del componente
 * @param {React.ReactNode} props.children - Elementos de filtro (normalmente componentes Grid)
 * @param {Function} props.onFilter - Función a ejecutar al hacer clic en el botón de filtrar
 * @param {Function} props.onReset - Función a ejecutar al hacer clic en el botón de limpiar
 * @param {string} props.filterButtonText - Texto para el botón de filtrado
 * @param {string} props.resetButtonText - Texto para el botón de reinicio
 * @param {Object} props.paperProps - Props adicionales para el componente Paper
 * @param {Object} props.gridProps - Props adicionales para el contenedor Grid principal
 */
const FilterBar = ({
  children,
  onFilter,
  onReset,
  filterButtonText = 'Filtrar',
  resetButtonText = 'Limpiar',
  paperProps = {},
  gridProps = {},
}) => {
  return (
    <Paper sx={{ p: 2, mb: 3, ...paperProps.sx }} {...paperProps}>
      <Grid container spacing={2} alignItems="center" {...gridProps}>
        {children}
        
        {/* Botones de acción */}
        <Grid item xs={12} md="auto" sx={{ display: 'flex', gap: 1 }}>
          <Button
            variant="contained"
            color="primary"
            startIcon={<SearchOutlined />}
            onClick={onFilter}
          >
            {filterButtonText}
          </Button>
          
          {onReset && (
            <Button
              variant="outlined"
              startIcon={<RestartAltOutlined />}
              onClick={onReset}
            >
              {resetButtonText}
            </Button>
          )}
        </Grid>
      </Grid>
    </Paper>
  );
};

FilterBar.propTypes = {
  children: PropTypes.node,
  onFilter: PropTypes.func.isRequired,
  onReset: PropTypes.func,
  filterButtonText: PropTypes.string,
  resetButtonText: PropTypes.string,
  paperProps: PropTypes.object,
  gridProps: PropTypes.object,
};

export default FilterBar;